import React from "react";

const noticeText = process.env.REACT_APP_FOOTER_NOTICE?.replace(/\\n/g, "\n").trim();

const FooterNotice = () => {
  if (!noticeText) return null;

  const [title, ...bodyLines] = noticeText
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <div className="w-full sm:w-11/12 mx-auto container mb-20">
      <p className="text-justify text-xs text-gray-500 w-full">
        {title && (
          <>
            <b>{title}</b>
            <br />
          </>
        )}
        {bodyLines.map((line) => (
          <React.Fragment key={line}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
    </div>
  );
};

export default FooterNotice;
